interface Props {
  color?: string;
}

export const EstatisticasIcon = (props: Props) => (
  <svg
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.00008 0H26.0001C26.3537 0 26.6928 0.140476 26.9429 0.390524C27.1929 0.640573 27.3334 0.979711 27.3334 1.33333V22.6667C27.3334 23.0203 27.1929 23.3594 26.9429 23.6095C26.6928 23.8595 26.3537 24 26.0001 24H2.00008C1.64646 24 1.30732 23.8595 1.05727 23.6095C0.807224 23.3594 0.666748 23.0203 0.666748 22.6667V1.33333C0.666748 0.979711 0.807224 0.640573 1.05727 0.390524C1.30732 0.140476 1.64646 0 2.00008 0ZM3.33341 2.66667V21.3333H24.6667V2.66667H3.33341ZM7.33342 13.3333H10.0001V18.6667H7.33342V13.3333ZM12.6667 5.33333H15.3334V18.6667H12.6667V5.33333ZM18.0001 9.33333H20.6667V18.6667H18.0001V9.33333Z"
      fill={props.color ?? "#666"}
    />
  </svg>
);
